import { useQuery } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useGetUserDetail = (userId) => {
  const data = useQuery(
    ["userDetail", userId],
    () => axiosClient.get(`/User/GetUserDetails?userId=${userId}`)
  );

  return data;
};
export default useGetUserDetail;
